// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"652e5292","171":"2ea8b9e5","245":"89e84194"}[chunkId] + ".chunk.js";
};